import { GroupByMode, newTaskSuffix } from '@griply/types';
import { getHiddenLinkedItemLabels, getNewTaskPrefill } from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';

import { TagHeader } from '../tag-header';
import { TreeTaskCard } from '../tree-task-card';
import { useTagRenderData } from './tag-render-context';

export const TagRenderItem: React.FC<RenderItemProps> = ({
  item,
  itemInstance,
  tree,
  isMultiSelectModifierPressed,
}) => {
  const {
    groupSettings,
    tasksMap,
    tasks,
    tags,
    today,
    denseFormat,
    defaultNewTaskDate,
  } = useTagRenderData();

  const type = item.type;

  if (type === TaskListItemTypes.Task) {
    const task = tasksMap[item.sourceId];
    if (!task) {
      return null;
    }
    const { hideGoal, hideLifeArea } = getHiddenLinkedItemLabels(
      task,
      groupSettings,
    );
    return (
      <TreeTaskCard
        task={task}
        tree={tree}
        item={itemInstance}
        tasks={tasks}
        isMultiSelectModifierPressed={isMultiSelectModifierPressed}
        displayDue={groupSettings.displayDue}
        hideGoal={hideGoal}
        hideLifeArea={hideLifeArea}
      />
    );
  }

  if (type === TaskListItemTypes.NewTask) {
    const groupSectionId = item.sourceId.replace(newTaskSuffix, '');
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.Tag,
      groupSectionId,
      groupSetting: groupSettings,
      today,
      defaultNewTaskDate,
    });
    return (
      <NewTaskRow
        tags={prefill.tagIds}
        date={prefill.startDate}
        startTime={null}
        duration={null}
        goal={prefill.goalId}
        lifeArea={prefill.lifeAreaId}
      />
    );
  }

  if (type === TaskListItemTypes.Tag) {
    return (
      <TagHeader item={itemInstance} tags={tags} denseFormat={denseFormat} />
    );
  }

  return null;
};
